module.exports = __webpack_public_path__ + "static/media/snoopyhot02.d2eb2674.gif";